import { Player } from '@lottiefiles/react-lottie-player';
import React, { useContext, useEffect, useState } from 'react';
import { Outlet, useParams, useSearchParams } from 'react-router-dom';
import loading_casino from "../../_asset/lottie/loading.json"
import { UserContext } from "../_root";
import api, { ApiErrorHandler } from "../../util/api";

export default function GameWindowRoot() {
    return (
        <div className={'game-window-layout'}>
            <Outlet />
        </div>
    )
}

interface getDataInterface {
    type: string,
    uid: string,
    vendor: string
}
export function GameWindow() {
    const { User, UserAuth } = useContext(UserContext)

    const params = useParams();
    const [location] = useSearchParams();

    const [gameData] = useState<getDataInterface>({
        type: location.get('type') || "",
        uid: location.get('uid') || "",
        vendor: location.get('vendor') || ""
    })
    const [openUrl, setOpenUrl] = useState<string>("")

    // function detectDevTool(allow: number | undefined): void {
    //     if (!allow || isNaN(+allow)) allow = 100;
    //     const start = +new Date();
    //     // debugger;
    //     const end = +new Date();
    //     if (isNaN(start) || isNaN(end) || end - start > allow) {
    //         // 개발자 도구가 open 된 것을 감지했을 때 실행할 코드 삽입
    //         setDebuggerCheck(true)
    //         console.log('개발자 도구가 감지되었습니다.');
    //     }else{
    //         setDebuggerCheck(false)
    //     }
    // }
    // useEffect(()=> {
    //     detectDevTool(undefined)
    // }, [])
    // useEffect(() => {
    //     if(!debuggerCheck){
    //         setGameData({
    //             type: location.get('type') || "",
    //             uid: location.get('uid') || "",
    //             vendor: location.get('vendor') || ""
    //         })
    //     }
    // }, [debuggerCheck]);
    useEffect(() => {
        let openUrl = window.location.origin
        if (gameData.uid && gameData.vendor) {
            const isLobbyUid = /lobby/i.test(gameData.uid)
            if (gameData.type === 'casino' || isLobbyUid) {
                let responseAPIUrl = `/api/game/lobbies/link/honor?vendor=${encodeURIComponent(gameData.vendor)}&id=${encodeURIComponent(gameData.uid)}`
                if (gameData.vendor === 'evolution I') {
                    responseAPIUrl = `/api/game/lobbies/link/oracle?vendor=${encodeURIComponent(gameData.vendor)}&id=${encodeURIComponent(gameData.uid)}`
                }
                api(responseAPIUrl)
                    .then(res => res.json())
                    .then((data: { link: string }) => {
                        if (data?.link) {
                            openUrl = data.link
                            setOpenUrl(openUrl)
                        }
                    })
                    .catch((res: Response) => {
                        ApiErrorHandler(res, () => {
                            window.close()
                        })
                    })
            } else {
                let responseAPIUrl = `/api/game/games/link/honor?uid=${encodeURIComponent(gameData.uid)}&vendor=${encodeURIComponent(gameData.vendor)}`
                if (params.vendor === 'PragmaticPlay J') {
                    responseAPIUrl = `/api/game/games/link/pragmatic?uid=${encodeURIComponent(gameData.uid)}`
                }
                api(responseAPIUrl)
                    .then(res => res.json())
                    .then((data: { link: string }) => {
                        if (data?.link) {
                            openUrl = data.link
                            setOpenUrl(openUrl)
                        }
                    })
                    .catch((res: Response) => {
                        ApiErrorHandler(res, () => {
                            window.close()
                        })
                    })
            }
        } else {
            alert('정상적인 접근이 아닙니다.')
            window.close()
        }
    }, [gameData, params.vendor])
    useEffect(() => {
        resizeViewportSet();
        window.addEventListener("resize", resizeViewportSet);

        return () => window.removeEventListener("resize", resizeViewportSet);
    }, []);
    return (
        <>
            {
                User && !UserAuth
                    ? <>
                        <p>로그아웃 되었습니다.</p>
                    </>
                    : openUrl
                        ? <iframe className={'iframe-game-window'}
                            title={'game-window'}
                            onLoad={resizeViewportSet}
                            src={openUrl}
                            frameBorder="0"></iframe>
                        : <>
                            <Player src={loading_casino} loop autoplay></Player>
                            <p>게임을 불러오는 중 입니다...</p>
                        </>
            }

        </>
    );
}

function resizeViewportSet() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
}
